import Cattle from './cattle'

export default Cattle
